export default function Tabs(theme) {
	return {
		MuiTabs: {
			styleOverrides: {
				root: {
					".MuiTabs-list": {
						columnGap: 39,
						[theme.breakpoints.up("lg")]: {
							columnGap: 100,
						},
					},
					".MuiTabs-scroller": {
						".MuiButtonBase-root": {
							padding: "22px 4px 17px",
							minWidth: "unset",
							color: theme.palette.grey[800],
							fontSize: 16,
							fontFamily: "'General Sans', sans-serif",
							fontWeight: 500,
							lineHeight: 1.25,
							[theme.breakpoints.up("lg")]: {
								padding: "27px 0",
							},
							"&.Mui-selected": {
								color: theme.palette.primary.main,
								fontWeight: 500,
							},
							"&:disabled": {
								color: "#BFC6CC",
							},
						},
					},
				},
			},
		},
	};
}
